module.exports = __webpack_public_path__ + "static/media/intro-photowall-26.d69dc27c.jpg";